<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <div class="datepicker-container with-button">
        <button v-on:click="triggerDatepicker">Trigger datepicker</button><br><br>
        <h3>Datepicker with button</h3>
        <div class="datepicker-trigger">
          <button id="datepicker-button-trigger">{{ formatDates(buttonDateOne, buttonDateTwo) || 'Select dates' }}</button>

          <AirbnbStyleDatepicker
            :trigger-element-id="'datepicker-button-trigger'"
            :mode="'single'"
            :date-one="buttonDateOne"
            :offset-y="10"
            :trigger="trigger"
            v-on:date-one-selected="function(val) { buttonDateOne = val }"
            v-on:closed="function() { trigger = false }"
          ></AirbnbStyleDatepicker>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import format from 'date-fns/format'
import TrackingProgress from '../../../components/TrackingProgress'

export default {
  data () {
    return {
      transDate: {
        headerName: '진료예약',
        chapterNum: 2,
        prevUrl: ''
      },
      dateFormat: 'D MMM',
      buttonDateOne: '',
      trigger: false
    }
  },
  mounted () {
    this.triggerDatepicker()
  },
  computed: {
  },
  methods: {
    formatDates: function (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      return formattedDates
    },
    triggerDatepicker: function () {
      this.trigger = !this.trigger
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/main";
</style>
